module.exports = __webpack_public_path__ + "lang/pt.json";


//////////////////
// WEBPACK FOOTER
// ./lang/pt.json
// module id = 82
// module chunks = d-game